import { assignPositions, preflopOrder, seatForPosition } from './positions';
import { dealForSpec } from './deal';
import { buildPots } from './sidepots';
/** Post `amount` from `player`'s stack, capping at their stack (short-stacked blind -> all-in). */
const postChips = (player, amount) => {
    const paid = Math.min(amount, player.stack);
    return {
        ...player,
        stack: player.stack - paid,
        committedThisStreet: player.committedThisStreet + paid,
        committedTotal: player.committedTotal + paid,
        allIn: player.allIn || player.stack - paid === 0,
    };
};
export const createHand = ({ handId, spec, buttonSeat, startingStacks }) => {
    const n = spec.villains.length + 1;
    if (buttonSeat < 0 || buttonSeat >= n) {
        throw new RangeError(`buttonSeat ${buttonSeat} out of range for ${n}-handed table`);
    }
    if (startingStacks && startingStacks.length !== n) {
        throw new RangeError(`startingStacks has ${startingStacks.length} entries for a ${n}-handed table`);
    }
    const positions = assignPositions(n, buttonSeat);
    const { holeCards } = dealForSpec(spec, n);
    const uniformStack = spec.stackDepthBB * spec.stakes.bb;
    const stackFor = (seat) => startingStacks?.[seat] ?? uniformStack;
    const ante = spec.stakes.ante ?? 0;
    let players = Array.from({ length: n }, (_, seat) => {
        const position = positions.get(seat);
        if (!position)
            throw new Error(`no position assigned for seat ${seat}`);
        const base = {
            seat,
            position,
            stack: stackFor(seat),
            committedThisStreet: 0,
            committedTotal: 0,
            folded: false,
            allIn: false,
        };
        if (seat === spec.heroSeat)
            base.holeCards = holeCards[seat];
        const villain = spec.villains.find((v) => v.seat === seat);
        if (villain)
            base.archetypeId = villain.archetypeId;
        return base;
    });
    if (ante > 0) {
        players = players.map((p) => postChips(p, ante));
        // antes are dead money, not part of street matching - undo the committedThisStreet bump.
        players = players.map((p) => ({ ...p, committedThisStreet: 0 }));
    }
    const sbSeat = seatForPosition(positions, 'SB');
    const bbSeat = seatForPosition(positions, 'BB');
    if (sbSeat === undefined || bbSeat === undefined)
        throw new Error('SB/BB seats not found');
    players = players.map((p) => {
        if (p.seat === sbSeat)
            return postChips(p, spec.stakes.sb);
        if (p.seat === bbSeat)
            return postChips(p, spec.stakes.bb);
        return p;
    });
    const order = preflopOrder(n, buttonSeat);
    const firstToAct = order.find((seat) => {
        const p = players.find((pp) => pp.seat === seat);
        return p && !p.folded && !p.allIn;
    });
    return {
        handId,
        spec,
        street: 'preflop',
        board: [],
        players,
        buttonSeat,
        pots: buildPots(players),
        currentBet: spec.stakes.bb,
        minRaiseTo: spec.stakes.bb + spec.stakes.bb,
        toAct: firstToAct ?? null,
        history: [],
        phase: 'acting',
    };
};
//# sourceMappingURL=init.js.map